import React from 'react';

class EntryList extends React.Component {
  render() {
    const styles = {
      gallery: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      },
      image: {
        width: 150,
        height: 150,
        borderRadius: 10,
        overflow: 'hidden',
        marginRight: 20,
        marginBottom: 16,
      }
    }

    const photos = this.props.photos.map((photo) =>
      <div style={styles.image}>
        <img src={photo.href} style={{minWidth:'100%', minHeight:'100%'}} alt="gallery" height="80" />
      </div>
    );

    return (
    <ul className={'contentField-container'} style={styles.gallery}>
      {photos}
    </ul>
    );
  }
}

export default EntryList;



// WEBPACK FOOTER //
// ./src/components/PhotoGallery.js